import React from 'react';
import { RefreshCw } from 'lucide-react';
import { BoardClickUpToolbarButton } from './BoardClickUpToolbarButton';

/** Botão "Atualizar" estilo ClickUp — toolbar direita do Board. */
export function BoardToolbarRefreshClickUpButton({
  onClick,
  disabled = false,
  isRefreshing = false,
}) {
  return (
    <BoardClickUpToolbarButton
      label="Atualizar"
      icon={RefreshCw}
      onClick={onClick}
      disabled={disabled}
      isLoading={isRefreshing}
      ariaLabel="Atualizar dados"
    />
  );
}
